module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [_c('div', {
    staticClass: "do-table__filters"
  }, [_c('div', {
    staticClass: "do-table__filters__left"
  }, [_c('Tabs', {
    staticStyle: {
      "height": "26px"
    },
    attrs: {
      "tabs": _vm.templateTabs,
      "selected": _vm.selectedTemplateTab,
      "isLarge": false
    },
    on: {
      "select": function($event) {
        _vm.selectedTemplateTab = $event
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Personer",
      "tags": _vm.personNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.toggleName,
      "clear": function($event) {
        _vm.selectedNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Grupper",
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.toggleTag,
      "clear": function($event) {
        _vm.selectedTags = []
      }
    }
  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": "Ansættelser",
      "tags": _vm.employmentTitles,
      "selectedTags": _vm.selectedEmploymentTitles,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.toggleEmploymentTitle,
      "clear": function($event) {
        _vm.selectedEmploymentTitles = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": "Organisationer",
      "tags": _vm.organisations,
      "selectedTags": _vm.selectedOrganisations,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.selectedOrganisation,
      "clear": function($event) {
        _vm.selectedOrganisations = []
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "do-table__filters__add__explainer-text"
  }, [_vm._v("Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.users.length) + " brugere")])], 1), _vm._v(" "), _c('div', {
    staticClass: "do-table__filters__add"
  }, [_c('DoEmploymentDropdown', {
    attrs: {
      "employmentTypes": _vm.employmentTemplates,
      "selectedEmploymentIds": _vm.selectedEmploymentIds
    },
    on: {
      "onTemplateCreated": _vm.onTemplateCreated,
      "onTemplateUpdated": _vm.onTemplateUpdated,
      "onTemplateDeleted": _vm.onTemplateDeleted,
      "select": _vm.onTemplateSelected
    }
  }), _vm._v(" "), (_vm.isSubmitting) ? _c('div', {
    staticClass: "do-spinner"
  }) : _c('span', [_vm._v("Valgt " + _vm._s(_vm.selectedEmploymentIds.length) + " " + _vm._s(_vm.selectedEmploymentIds.length === 1 ? 'ansættelse' : 'ansættelser'))])], 1)]), _vm._v(" "), _c('SalarySettingsUsersTable', {
    attrs: {
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
      "filteredUsers": _vm.filteredUsers,
      "isImportOfEmployments": true,
      "employmentTemplates": _vm.employmentTemplates,
      "selectedEmploymentIds": _vm.selectedEmploymentIds,
      "isShowEmploymentNumber": _vm.isShowEmploymentNumber,
      "rowActionLabel": _vm.rowActionLabel
    },
    on: {
      "toggleEmployment": _vm.toggleEmployment,
      "toggleAllEmployments": _vm.toggleAllEmployments,
      "editEmployment": _vm.onEditEmployment,
      "setTheEditUser": function($event) {
        return _vm.$emit('setTheEditUser', $event)
      },
      "editSsn": _vm.onEditSsn,
      "removeEmployment": function($event) {
        _vm.employmentRemovalTarget = $event
      }
    }
  }), _vm._v(" "), (_vm.theSsnUser) ? _c('SalarySsnModal', {
    attrs: {
      "user": _vm.theSsnUser
    },
    on: {
      "close": function($event) {
        _vm.theSsnUser = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.templateRemovalTarget) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": _vm.cancelRemoveTemplate
    }
  }, [_c('div', {
    staticClass: "remove-template-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "remove-template-modal__header"
  }, [_c('h2', [_vm._v("Fjern stillingskategori")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle remove-template-modal__close",
    on: {
      "click": _vm.cancelRemoveTemplate
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "remove-template-modal__content"
  }, [_c('p', [_vm._v("\n            Ønsker du at fjerne stillingskategorien\n            "), (_vm.templateRemovalTarget.employment.title) ? _c('strong', [_vm._v(_vm._s(_vm.templateRemovalTarget.employment.title))]) : _vm._e(), _vm._v("\n            fra ansættelsen på "), _c('strong', [_vm._v(_vm._s(_vm.templateRemovalTarget.user.name))]), _vm._v("?\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "remove-template-modal__buttons"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.cancelRemoveTemplate
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.isRemovingTemplate,
      'do-bttn--submit--loading': _vm.isRemovingTemplate
    },
    on: {
      "click": _vm.confirmRemoveTemplate
    }
  }, [_vm._v("\n              Fjern\n            ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.employmentRemovalTarget) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": _vm.cancelRemoveEmployment
    }
  }, [_c('div', {
    staticClass: "remove-template-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "remove-template-modal__header"
  }, [_c('h2', [_vm._v("Fjern ansættelse")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle remove-template-modal__close",
    on: {
      "click": _vm.cancelRemoveEmployment
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "remove-template-modal__content"
  }, [_c('p', [_vm._v("\n            Vil du fjerne ansættelsen\n            "), _c('strong', [(_vm.employmentRemovalTarget.employment.employment_number) ? [_vm._v(_vm._s(_vm.employmentRemovalTarget.employment.employment_number) + " -")] : _vm._e(), _vm._v("\n              " + _vm._s(_vm.employmentRemovalTarget.employment.source_title || _vm.employmentRemovalTarget.employment.title) + "\n            ")], 2), _vm._v("\n            for "), _c('strong', [_vm._v(_vm._s(_vm.employmentRemovalTarget.user.name))]), _vm._v(" i Docendo?\n          ")]), _vm._v(" "), _c('p', [_vm._v("Den vil stadig være i lønsystemet.")])]), _vm._v(" "), _c('div', {
    staticClass: "remove-template-modal__buttons"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.cancelRemoveEmployment
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.isRemovingEmployment,
      'do-bttn--submit--loading': _vm.isRemovingEmployment
    },
    on: {
      "click": _vm.confirmRemoveEmployment
    }
  }, [_vm._v("\n              Fjern ansættelse\n            ")])])])])]) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bbe5ff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsersOpus.vue
// module id = 1869
// module chunks = 1